export default __webpack_public_path__ + "static/media/hideaway-site-icon.3643ff35.jpg";